
module.exports = {"attributes":{"width":"16","height":"13","viewBox":"0 0 16 13"},"content":"<path d=\"M3 4H1L0 5v3l1 1h2l4 4h1V0H7L3 4zm11.7 2.5c0 2-.7 3.8-1.8 5.2l.4.4c1.6-1.3 2.6-3.3 2.6-5.6s-1-4.3-2.6-5.6l-.4.4c1.2 1.5 1.8 3.3 1.8 5.2m-3.7 0c0 1.1-.3 2.2-.9 3.1l.5.5c.8-1 1.4-2.2 1.4-3.6s-.6-2.6-1.5-3.5l-.5.5c.6.8 1 1.9 1 3\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
